import { IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';
import { EnvironmentProviders, ɵIMAGE_CONFIG as IMAGE_CONFIG, makeEnvironmentProviders } from '@angular/core';
import { ResizeService } from '@df/ui/common/resize.service';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NDfModuleImage } from './df-module-image.interface';

export const providers = (config?: DeepPartial<NDfModuleImage.IConfig>) => [
    {
        provide: NDfModuleImage.CONFIG,
        useFactory: () => {
            return defaultsDeep(config || {}, <NDfModuleImage.IConfig>{
                placeholder: false,
                placeholderBlur: false
            });
        }
    },
    {
        provide: IMAGE_LOADER,
        useFactory: (resizeService: ResizeService) => (config: ImageLoaderConfig) => resizeService.loader(config),
        deps: [ResizeService]
    },
    {
        provide: IMAGE_CONFIG,
        useValue: {
            breakpoints: [128, 256, 384, 414, 640, 750, 828, 1080, 1280, 1366, 1440, 1600, 1920, 2560]
        }
    }
];

/**
 * @usage Angular 18+
 */
export function provideDfModuleImage(
    config?: DeepPartial<NDfModuleImage.IConfig> | DeepPartial<NDfModuleImage.IModuleOptions>
): EnvironmentProviders {
    return makeEnvironmentProviders(providers(config));
}

export const oldProviders = (config?: DeepPartial<NDfModuleImage.IModuleOptions>) => [
    {
        provide: NDfModuleImage.OPTIONS,
        useFactory: () => {
            return defaultsDeep(config || {}, <NDfModuleImage.IModuleOptions>{
                ignorRetina: false,
                viewportTollerance: 300,
                viewportTolleranceHorizontal: [400, 1000, 1000, 1000]
            });
        }
    }
];

/**
 * Old `image` directive providers
 * @deprecated
 * @usage Angular 18+
 */
export function provideImage(config?: DeepPartial<NDfModuleImage.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders(oldProviders(config));
}
